<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9SVAWl/tc-custom/9781477319222.jpg?1705015261084" alt="This image is the cover for the book Texas Seafood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texas Seafood
      </h1>
      <p class="bookDescription body article font2">
        <b>“A valuable compendium no matter where you live, </b><b><i>Texas Seafood</i></b><b> encourages you to explore uncommon varieties from your local fishmonger.” —<i>The </i></b><b><i>Wall Street Journal</i></b><br/>  <br/> The abundance of seafood available from the northwest Gulf of Mexico includes hundreds of delicious species that are often overlooked by consumers. Celebrating this regional bounty, <i>Texas Seafood</i> showcases the expertise of longtime fishmongers and chefs PJ and “Apple Srimart” Stoops. Readers will find familiar fish like Red Snapper along with dozens of little-known finfish and invertebrates, including tunas, mackerels, rays, and skates, as well as bivalves, shrimps, crabs, and other varieties, many of which are considered “bycatch” (seafood that a fisher didn’t intend to catch), but are no more difficult to prepare and just as delicious as those commonly found at your local supermarket.<br/>  <br/> The Stoopses provide a complete primer on sourcing these wild-caught delicacies, with fascinating details about habitats and life cycles as well as practical advice on how to discern quality. <i>Texas Seafood</i> concludes with simple, delectable recipes, many infused with the flavors of Apple’s Thai heritage. Dishes such as Steamed Curried Crab, Crispy White Shrimp, Escolar on a Grill with Green Mango Salad, Cast-Iron-Roasted Shortfin Mako Shark with Rio Grande Grapefruit, and Chicken-Fried Ribbonfish are just a few ways to savor the best of the Gulf.<br/>  <br/><b>“By documenting in such detail what’s below the surface in our Texas waters, [<i>Texas Seafood</i>] reveals a treasure. Not just for a local market but beyond: the national and even global market.” —<i>Edible Houston</i></b><br/>  <br/><b>“An important addition to every local foodie’s culinary library.” —<i>Edible San Antonio</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        PJ Stoops, Benchalak Srimart Stoops
      </h2>
      
      <p class="authorDescription body article">PJ Stoops and Benchalak Srimart Stoops are experienced fishmongers and were the chefs at Foreign Correspondent, a farm-to-table northern Thai eatery that was named one of Bon Appétit’s Best New Restaurants in 2015. PJ Stoops was also the driving force behind Houston’s “Total Catch Market,” a regular event that sold bycatch seafood from the Gulf of Mexico.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c3c6b03